var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSip = function SvgSip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 14"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.412 1.908c-.905 1.47.832 5.615 2.949 7.732l.002-.002c2.117 2.116 6.258 3.855 7.73 2.95 1.01-.621.915-3.075.15-3.82-.506-.493-2.055-.748-2.693-.62-.2.04-.76.617-1.07.939l-.15.154c-.23.228-1.69-1.02-2.124-1.453L7.6 9.398l1.605-1.611C8.772 7.354 7.53 5.899 7.76 5.671q.057-.058.153-.15c.322-.312.9-.87.94-1.07.127-.64-.128-2.188-.62-2.694-.746-.765-3.2-.86-3.821.15",
    clipRule: "evenodd"
  })));
};
export default SvgSip;